import { render, staticRenderFns } from "./BiomarkerReverseMechanismLinkSummary.vue?vue&type=template&id=c1f1ec14&scoped=true"
import script from "./BiomarkerReverseMechanismLinkSummary.vue?vue&type=script&lang=js"
export * from "./BiomarkerReverseMechanismLinkSummary.vue?vue&type=script&lang=js"
import style0 from "./BiomarkerReverseMechanismLinkSummary.vue?vue&type=style&index=0&id=c1f1ec14&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1f1ec14",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/CFDE Knowledge - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c1f1ec14')) {
      api.createRecord('c1f1ec14', component.options)
    } else {
      api.reload('c1f1ec14', component.options)
    }
    module.hot.accept("./BiomarkerReverseMechanismLinkSummary.vue?vue&type=template&id=c1f1ec14&scoped=true", function () {
      api.rerender('c1f1ec14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/biomarkerNetwork/BiomarkerReverseMechanismLinkSummary.vue"
export default component.exports